var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvcIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1144 57.9794C27.1806 51.3588 21.25 40.2775 21.25 28.3375V25.8625L38.125 20.2375V12.3325L13.75 20.4588V28.3375C13.75 42.7919 20.9294 56.2056 32.9537 64.2213L38.125 67.6675V58.6544L37.1144 57.9794Z",
    fill: "#38383D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.875 12.3325V20.2394L58.75 25.8644V28.3375C58.75 40.2775 52.8194 51.3588 42.8856 57.9813L41.875 58.6544V67.6675L47.0462 64.2213C59.0706 56.2056 66.25 42.7919 66.25 28.3375V20.4588L41.875 12.3325Z",
    fill: "#9AFF42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvcIcon6);
export default __webpack_public_path__ + "static/media/svc_icon6.5c2e87751a48723d3434a641a994f91a.svg";
export { ForwardRef as ReactComponent };